import Base from "@/plugins/Base";

const module = {
    namespaced: true,
    state: () => ({
        user: Base.LocalStorage.get('visitor_user') || null,
        pin: Base.LocalStorage.get('visitor_pin') || null,
        tabIndex: Base.LocalStorage.get('visitor_active_tab') || 0,
        maxTabIndex: Base.LocalStorage.get('visitor_max_tab') || 0,
        tempForm: Base.LocalStorage.get('visitor_temp_form') || {
            programLevel: null,
            info: {},
            program: {},
            courses: {},
            documents: {}
        }
    }),
    mutations: {
        setUser(state, user) {
            state.user = user;
            if (user) {
                Base.LocalStorage.set('visitor_user', user);
            } else {
                Base.LocalStorage.remove('visitor_user');
            }
        },
        setPin(state, pin) {
            state.pin = pin;
            if (pin) {
                Base.LocalStorage.set('visitor_pin', pin);
            } else {
                Base.LocalStorage.remove('visitor_pin');
            }
        },
        updateTabIndex(state, index) {
            state.tabIndex = index;
            Base.LocalStorage.set('visitor_active_tab', index);
        },
        updateMaxTabIndex(state, index) {
            state.maxTabIndex = index;
            Base.LocalStorage.set('visitor_max_tab', index);
        },
        updateTempForm(state, data) {
            state.tempForm = data;
            Base.LocalStorage.set('visitor_temp_form', data);
        }
    },
    actions: {
        setVisitorApplicationUser({ commit }, user) {
            commit('setUser', user);
        },
        setPin({ commit }, pin) {
            commit('setPin', pin);
        },
        logout({ commit }) {
            commit('setUser', null);
            commit('setPin', null);
            commit('updateTabIndex', 0);
            commit('updateMaxTabIndex', 0);
            commit('updateTempForm', {
                programLevel: null,
                info: {},
                program: {},
                courses: {},
                documents: {}
            });
            Base.LocalStorage.remove('visitor_active_tab');
            Base.LocalStorage.remove('visitor_max_tab');
            Base.LocalStorage.remove('visitor_temp_form');
        },
        handleNextStep({ state, commit }, { section, data }) {
            const newFormData = { ...state.tempForm, [section]: data };
            if (section === 'program' && data.appliedProgram) {
                newFormData.programLevel = data.appliedProgram.level;
            }
            commit('updateTempForm', newFormData);

            const nextIndex = state.tabIndex + 1;
            if (nextIndex > state.maxTabIndex) {
                commit('updateMaxTabIndex', nextIndex);
            }
            commit('updateTabIndex', nextIndex);
        },
        resetApplication({ dispatch }) {
            dispatch('logout');
        },
        setApplicationData({ commit }, data) {
            if (!data) return;
            const firstProgram = Array.isArray(data.programs) && data.programs.length ? data.programs[0] : null;
            const tempForm = {
                programLevel: firstProgram?.program_level || 'l',
                info: {
                    name: data.name || null,
                    surname: data.surname || null,
                    gender: data.gender || null,
                    nationality_code: data.nationality_code || 'TR',
                    phone: data.phone || null,
                    email: data.email || null,
                    city_id: data.city_id || null,
                    district_id: data.district_id || null,
                    address: data.address || null,
                    education_status: data.education_status || null,
                    education_status_name: data.education_status_name || null,
                    father_name: data.father_name || null,
                    mother_name: data.mother_name || null,
                    birth_place: data.birth_place || null,
                    last_school: data.last_school || null,
                    last_school_name: data.last_school_name || null,
                    national_id: data.national_id || null,
                    passport_number: data.passport_number || null
                },
                program: firstProgram ? {
                    appliedProgram: {
                        level: firstProgram.program_level || null,
                        level_name: data.program_level_name || null,
                        faculty: firstProgram.faculty_code || null,
                        faculty_name: firstProgram.faculty_name || null,
                        program: firstProgram.program_code || null,
                        program_name: data.program_name || null,
                        department: firstProgram.department_id || null,
                        thesis: firstProgram.graduate_type || null
                    }
                } : {},
                courses: {
                    courses: Array.isArray(data.courses) ? data.courses : []
                },
                serverDocuments: Array.isArray(data.documents) ? data.documents : []
            };
            let maxTab = 0;
            if (data.name) maxTab = 1;
            if (firstProgram) maxTab = 2;
            if (Array.isArray(data.courses) && data.courses.length) maxTab = 3;
            if (Array.isArray(data.documents) && data.documents.length) maxTab = 4;
            commit('updateTempForm', tempForm);
            commit('updateMaxTabIndex', maxTab);
            commit('updateTabIndex', maxTab);
        }
    },
    getters: {
        isLoggedIn: (state) => !!state.user && !!state.pin,
        getUser: (state) => state.user,
        getPin: (state) => state.pin,
        getCredentials: (state) => {
            if (!state.user || !state.pin) return null;
            const creds = { pin: state.pin };
            if (state.user.national_id) {
                creds.national_id = state.user.national_id;
            } else if (state.user.passport_number) {
                creds.passport_number = state.user.passport_number;
            }
            return creds;
        }
    }
}
export default module;
